/*
A hand ordering for 6-handed hold'em generated via an evolution program.
For details on the creation of this ordering, please visit
http://pokercoder.blogspot.com/2006/07/towards-meaningful-ordering-of-hands.html
Copyright 2012 ProPokerTools.com.
Unlimited use so long as credit is given to ProPokerTools.com.
*/

export const sixMaxRankings = [
  'AA',
  'KK',
  'QQ',
  'JJ',
  'TT',
  'AKs',
  'AK',
  'AQs',
  '99',
  'AJs',
  'AQ',
  '88',
  'ATs',
  'AJ',
  'KQs',
  '77',
  'KJs',
  'AT',
  'KQ',
  'A9s',
  'KTs',
  '66',
  'A8s',
  'QJs',
  'A7s',
  'KJ',
  'QTs',
  'A5s',
  'A9',
  'A6s',
  'JTs',
  '55',
  'K9s',
  'A4s',
  'KT',
  'A3s',
  'A8',
  'QJ',
  'Q9s',
  'A2s',
  'K8s',
  'J9s',
  '44',
  'K7s',
  'T9s',
  'QT',
  'A7',
  'K6s',
  'A5',
  'JT',
  'Q8s',
  'K9',
  'A6',
  'K5s',
  'J8s',
  'T8s',
  'A4',
  '33',
  '98s',
  'K4s',
  'A3',
  'Q7s',
  'Q6s',
  'Q9',
  'K3s',
  'K2s',
  'A2',
  'J7s',
  'K8',
  'J9',
  'T7s',
  '87s',
  'T9',
  'Q5s',
  '97s',
  'K7',
  '22',
  'Q4s',
  'K6',
  'J6s',
  'Q8',
  '86s',
  '76s',
  'T6s',
  'Q3s',
  'K5',
  '96s',
  'J8',
  'J5s',
  'T8',
  'Q2s',
  '98',
  'K4',
  '65s',
  'J4s',
  'Q7',
  '75s',
  'Q6',
  'J3s',
  'K3',
  'J7',
  '95s',
  '85s',
  'T5s',
  'T7',
  'K2',
  '87',
  '54s',
  'J2s',
  '97',
  'Q5',
  'T4s',
  '64s',
  'T3s',
  '74s',
  'Q4',
  '76',
  'J6',
  '84s',
  'T2s',
  '94s',
  'T6',
  '53s',
  'Q3',
  '86',
  'J5',
  '93s',
  '96',
  'Q2',
  '63s',
  '92s',
  '65',
  '43s',
  'J4',
  '73s',
  '75',
  '83s',
  '52s',
  'J3',
  '85',
  'T5',
  '82s',
  '95',
  '54',
  'J2',
  '42s',
  'T4',
  '62s',
  '64',
  '72s',
  '32s',
  'T3',
  '74',
  '84',
  'T2',
  '53',
  '94',
  '93',
  '43',
  '63',
  '92',
  '73',
  '83',
  '52',
  '82',
  '42',
  '62',
  '72',
  '32',
];
